/* istanbul ignore file */
// no business logic, will cover it with TODO: cypress
import { mountNotification } from '../../../components/Notification';
import { CONTAINER_NOTIFICATION_FAILED, CONTAINER_NOTIFICATION_SERVICE_NOT_AVAILABLE, CONTAINER_NOTIFICATION_SUCCESS, NotificationType } from 'Constant';

/**
 * Export mountNotifications
 *
 * @export mountNotifications
 */
 export const mountNotifications = () => {
    const containerNotificationSuccess = document.getElementById(CONTAINER_NOTIFICATION_SUCCESS);
    const containerNotificationFailed = document.getElementById(CONTAINER_NOTIFICATION_FAILED); // Only for landuse form
    const containerNotificationServiceNotAvailable = document.getElementById(CONTAINER_NOTIFICATION_SERVICE_NOT_AVAILABLE); // Only for registration form

    const { textSuccess, textSuccessContent, textFail, textFailContent } = (window as any).additionalPageOptions.notifications;

    if (containerNotificationSuccess) {
        mountNotification(containerNotificationSuccess, textSuccess, textSuccessContent, NotificationType.SUCCESS);
    }

    if (containerNotificationServiceNotAvailable) {
        mountNotification(containerNotificationServiceNotAvailable, textFail, textFailContent, NotificationType.ERROR);
    }

    if (containerNotificationFailed) {
        mountNotification(containerNotificationFailed, textFail, textFailContent, NotificationType.INFO);
    }
};
